import { render } from "./Appointments.vue?vue&type=template&id=a1aed5d6&ts=true"
import script from "./Appointments.vue?vue&type=script&lang=ts"
export * from "./Appointments.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/asaskevich/Work/sequoia-cabinet/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__